var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3508_10251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.78049 0.83733 6.79048C0.00476615 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3165 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9969 8.08359 20.8369 5.28753 18.7747 3.22531C16.7125 1.16309 13.9164 0.00315432 11 0V0ZM11 20.1667C9.18701 20.1667 7.41473 19.629 5.90728 18.6218C4.39983 17.6146 3.22491 16.1829 2.53111 14.5079C1.83731 12.8329 1.65578 10.9898 2.00947 9.21167C2.36317 7.43351 3.23621 5.80017 4.51819 4.51819C5.80017 3.23621 7.43352 2.36317 9.21168 2.00947C10.9898 1.65577 12.8329 1.8373 14.5079 2.5311C16.1829 3.22491 17.6146 4.39982 18.6218 5.90727C19.6291 7.41472 20.1667 9.187 20.1667 11C20.164 13.4303 19.1974 15.7604 17.4789 17.4789C15.7604 19.1974 13.4303 20.164 11 20.1667Z",
    fill: "#ED272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 4.58325C10.7556 4.58325 10.5224 4.67983 10.3505 4.85174C10.1786 5.02365 10.082 5.2568 10.082 5.49992V12.8333C10.082 13.0764 10.1786 13.3095 10.3505 13.4814C10.5224 13.6533 10.7556 13.7499 10.9987 13.7499C11.2418 13.7499 11.475 13.6533 11.6469 13.4814C11.8188 13.3095 11.9154 13.0764 11.9154 12.8333V5.49992C11.9154 5.2568 11.8188 5.02365 11.6469 4.85174C11.475 4.67983 11.2418 4.58325 10.9987 4.58325Z",
    fill: "#ED272F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9154 16.4999C11.9154 15.9937 11.505 15.5833 10.9987 15.5833C10.4924 15.5833 10.082 15.9937 10.082 16.4999C10.082 17.0062 10.4924 17.4166 10.9987 17.4166C11.505 17.4166 11.9154 17.0062 11.9154 16.4999Z",
    fill: "#ED272F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_10251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.f3ebe481ffafac6cb44945efaf9660f0.svg";
export { ForwardRef as ReactComponent };